import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

/** Ejecuta fn sobre cada ítem con límite de concurrencia (evita agotar el pool de conexiones DB). */
export async function mapWithConcurrency<T>(items: readonly T[], concurrency: number, fn: (item: T) => Promise<void>): Promise<void> {
	if (items.length === 0) return
	const limit = Math.max(1, Math.min(concurrency, items.length))
	let index = 0
	const worker = async () => {
		while (index < items.length) {
			const i = index++
			await fn(items[i])
		}
	}
	await Promise.all(Array.from({ length: limit }, worker))
}
